export const skeletons: number[] = Array(6).fill(0);
